/* eslint-disable */
/* eslint-disable prettier/prettier */
/* eslint-disable camelcase */
import axios from 'axios';

import { config } from '../../../config';

var token = '';
const paymentLink = axios.create({ baseURL: config.API_GATEWAY_PAGAMENTOS });
const api = {
	token: setToken,
	link: {
		getPaymentLink: getPaymentLink,
		paymentChargeBack: paymentChargeBack,
		cancelLink: cancelLink,
	},
};

async function setToken(client_document) {
	return await paymentLink.get('/v2/credentials/' + client_document, {
		// removendo o header authorization
		// porque o CORs headers não aceita authorization
		transformRequest: (data, headers) => {
			delete headers.Authorization
			return data
		}
	}).then(res => {
		token = res.data.local_auth_credential
	}).catch(err => {
		token = ''
	})
}

async function getPaymentLink(page, items_per_page, status = null) {
	if (status)
		return await paymentLink.get("/v3/billing/list/" + page + "/" + items_per_page + "?status=" + status, { headers: { 'Content-Type': 'application/json', Authorization: 'Basic ' + token } });
	return await paymentLink.get("/v3/billing/list/" + page + "/" + items_per_page, { headers: { 'Content-Type': 'application/json', Authorization: 'Basic ' + token } });
}

async function paymentChargeBack(
	card_number,
	expiration_date,
	transaction_detail
) {
	var card_number_formated = card_number
		.replace(' ', '')
		.replace(' ', '')
		.replace(' ', '')
		.replace(' ', '');
	var array_date = expiration_date.split('/');
	var expiration_month = array_date[0];
	var expiration_year = array_date[1];

	var charge_back_obj = {
		link_cryptogram: transaction_detail.cryptogram,
		payment_id: transaction_detail.payer_details.status_payment.payment_id,
		amount: transaction_detail.amount,
		card: {
			pan: card_number_formated,
			expiry_mm: expiration_month,
			expiry_yyyy: expiration_year,
		},
	};
	await paymentLink.post('v2/payments/cancel-link', charge_back_obj, {
		headers: { Authorization: `Basic ${token}` },
	});
}

async function cancelLink(transaction_detail) {
	var linkData = {
		link_cryptogram: transaction_detail.cryptogram,
		amount: transaction_detail.amount,
	};
	await paymentLink.post('v2/payments/cancel-link', linkData, {
		headers: { Authorization: `Basic ${token}` },
	});
}

export default api;
